import type { ClientPortfolioReportingSummaryResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	dateFormatter,
	SHORT_DATE_FORMAT,
} from "web_myplann/Shared/Utils/dateFormatters";

export const getSummaryValueDate = (
	summary: ClientPortfolioReportingSummaryResponseDTO | null | undefined,
): string | null =>
	summary?.valueDate
		? dateFormatter(summary.valueDate, SHORT_DATE_FORMAT)
		: null;
